import React from 'react';
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {FullSafezoneContentBox} from "./boxes/full-safezone-content.box";
import {OnErrorComponent} from "../on-error/on-error.component";
import {observer} from "mobx-react";

export interface FullSafezoneComponentProps{
  onRender: () => void;
}

export const FullSafezoneComponent = observer(
  class FullSafezoneComponent extends OrbitComponent<FullSafezoneComponentProps> {

    componentDidMount() {
      super.componentDidMount();
      this.props.onRender();
    }

    private _renderError(){
      if(this.services.safezone.hasError){
        return <OnErrorComponent
            onRetryButtonClick={() => this._retryCreateSafeZone()}
            onCloseButtonClick={() => this.services.drawer.right.closeDrawer()}
          />
      } else {
        return null;
      }
    }

    private _retryCreateSafeZone(){
      this.services.safezone.reconnectToSafezone();
    }

    render() {
      return (
        <FullSafezoneContentBox id="FullSafeZoneContainer">
          {this._renderError()}
        </FullSafezoneContentBox>
      )
    }
  }
);
